import actionTypes from 'constants/finalWizardConstants';

export function goToFinalStep(step) {
  return (dispatch) => {
    dispatch({ type: actionTypes.FINAL_GO_TO_STEP, payload: step });
  };
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/actions/finalWizardActions.js